import {
    get,
    post
} from '@/utils/request'

const SERVICE_URL = '/project-service/v1'

export function deleteProject(params, pathParam) {
    return get(SERVICE_URL + '/project/deleteProject', params, pathParam)
}
export function queryById(params, pathParam) {
    return get(SERVICE_URL + '/project/getById', params, pathParam)
}
export function projectList(params) {
    return post(SERVICE_URL + '/project/projectList', params)
}
export function createProject(params) {
    return post(SERVICE_URL + '/project/insertProject', params)
}
export function editProject(params) {
    return post(SERVICE_URL + '/project/updateProject', params)
}


/**产销计划 */
export function removeDimension(params) {
    return post(SERVICE_URL + '/project/deleteDimension', params)
}
export function queryDimensionById(params, pathParam) {
    return get(SERVICE_URL + '/project/getDimensionId', params, pathParam)
}
export function  getDimensionList(params) {
    return post(SERVICE_URL + '/project/getProjectProduceDimension', params)
}
export function createDimension(params) {
    return post(SERVICE_URL + '/project/insertDimension', params)
}
export function editDimension(params) {
    return post(SERVICE_URL + '/project/updateDimension', params)
}


/** 汇率表 */
export function removeRate(params, pathParam) {
    return get(SERVICE_URL + '/project/deleteRate', params, pathParam)
}
export function projectRateById(params, pathParam) {
    return get(SERVICE_URL + '/project/projectRateById', params, pathParam)
}
export function getProjectRateList(params) {
    return post(SERVICE_URL + '/project/projectRateList', params)
}
export function createRate(params) {
    return post(SERVICE_URL + '/project/insertRate', params)
}
export function editRate(params) {
    return post(SERVICE_URL + '/project/updateRate', params)
}